import * as React from 'react';
import { Container as Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IHistory, IForms } from '../../../interfaces';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { ListPage } from '../../reusableComponents/ListPage';
import { Loader } from '../../reusableComponents/Loader';
import { ListItem } from './preExcavationChecklistListItem';
import { Pagination } from '../../reusableComponents/Pagination';
import { DeleteConfirmationModal } from '../../reusableComponents/DeleteConfirmationModal';
import { AlertModal } from '../../reusableComponents/ModalComponents/AlertModal';
import {getAllTexas811Forms} from "../../../services/texas811Service";
import {PreExcavationChecklistV2Model} from "../../../model/PreExcavationChecklistModel";
import { ExcelExport } from '../../reusableComponents/ExcelExport';
import { CommonFilter } from '../../reusableComponents/FilterComponents/CommonFilter';
import { setLoading, setSuccess} from '../../../actions/loadingActions'; 
declare var require: any;
const queryString = require('query-string');

export interface IPreExcavationChecklistListPageProps {
    instances: PreExcavationChecklistV2Model[];
    history?: IHistory;
    totalPageCount: number;
    forms: IForms;
    axiosPreviousToken: any;
}

export class PreExcavationChecklistListImpl extends React.PureComponent<IPreExcavationChecklistListPageProps, {}> {
    constructor(props: IPreExcavationChecklistListPageProps | Readonly<IPreExcavationChecklistListPageProps>) {
        super(props);
    }
    sortListing = { 0: 'date', 1: 'username', 2:'crewForeman', 3: 'oneCallTicketNo' };

    promise = async (pageNumber = queryString.parse(this.props.history?.location['search']).pageNumber || 1) => { 
        let urlParams = queryString.parse(this.props.history?.location['search']) || [];  
        await this.getReportData(urlParams.sortingIndex);
        return null;
    }

    getReportData = async (sortIndex='false') => { 
        setLoading('AllListPage'); 
        let urlParams = queryString.parse(this.props.history?.location['search']) || {}; 
        urlParams.sortIndexField = this.sortListing[sortIndex];
        urlParams.axiosPreviousToken = this.props.axiosPreviousToken;
        await getAllTexas811Forms( urlParams, this.props.forms, 'preExcavationChecklistV2'  );
        setSuccess('AllListPage'); 
    }
    renderAddNewFormButton = () => {
        const { history } = this.props;
        return (
            <button className="add-new-report"
                    onClick={() => { history?.push('/preExcavationChecklist-v2/create'); }}
            >
                +
            </button>
        );
    } 

    renderContent = () => {
        const { instances } = this.props;
        return <div className="office-safety-wrapper"> 
            <CommonFilter onApply={this.getReportData} forms={this.props.forms} history={this.props.history} />
            {<ExcelExport formType="preExcavationChecklistV2" fileName="Pre-Excavation Checklist Report" />}
            <> <ListPage
                    pageHeading="Pre-Excavation Checklist List"
                    instances={instances}
                    rowHeadings={['Date Submitted','Observer', 'Crew Foreman', 'OneCall Ticket #' ]}
                    listItemComponent={ListItem}
                    isSearchable={true}
                    searchableBy={[ 'date', 'username']}
                    searchPlaceHolder="Enter one-call ticket, foreman, job to search..."
                    emptyInstancesMessage="No pre-excavation checklist report found."
                    sm={[2, 3, 2, 3]}
                    currentPage={queryString.parse(this.props.history?.location['search']).pageNumber || 1}
                    rowSortings={this.sortListing} 
                    promise={(sortIndex) => this.getReportData(sortIndex)}
                    forms={this.props.forms}
                    history={this.props.history }
                />
                {this.renderAddNewFormButton()} 
                <Pagination
                    history={this.props.history}
                    promise={(pageNumber) => this.promise(pageNumber)}
                    totalCount={this.props.totalPageCount}
                    Model={PreExcavationChecklistV2Model as any}
                    identifier="PreExcavationChecklistReports"
                /> 
            </>
        </div>;
    }

    render() {
        return (
            <BasePage className="wide-list-page" >
                <DeleteConfirmationModal id="delete-confirmation" />
                <AlertModal id="delete-success" />
                <Grid className="office-safety-report-list" style={{ width: '100%' }}>
                    <Async
                        identifier="PreExcavationChecklistReports"
                        promise={this.promise}
                        loader={<Loader />}
                        error={<ErrorPage />}
                        content={this.renderContent()}
                    />
                </Grid>
            </BasePage >
        );
    }
}

export function mapStateToProps(state: any) {
    const instances = PreExcavationChecklistV2Model.list();
    return { instances, totalPageCount: state.miscellaneous.get('listCount'), forms: state.forms, axiosPreviousToken: state.miscellaneous.get('axiosPreviousToken'), };
}

export const PreExcavationChecklistList = withRouter(connect<IPreExcavationChecklistListPageProps, any, any>
(mapStateToProps)(PreExcavationChecklistListImpl));
